export let Visa = () => {
  return (
    <div>
      <svg
        id="visa-light-large"
        xmlns="http://www.w3.org/2000/svg"
        width="70"
        height="70"
        viewBox="0 0 51 28">
        <rect id="card_bg" width="51" height="28" rx="4" fill="#dfe3e8" />
        <path
          id="visa-logo"
          d="M18.735,9.52a8.552,8.552,0,0,1-2.867-.491l.474-2a5.976,5.976,0,0,0,2.617.6h.07c.784-.01,1.575-.3,1.575-.91.011-.392-.359-.7-1.366-1.15-.988-.439-2.3-1.176-2.3-2.51,0-1.8,1.811-3.06,4.4-3.06a7.7,7.7,0,0,1,2.467.41l-.462,2a5.392,5.392,0,0,0-2.114-.432c-.161,0-.325.007-.485.022-.761.091-1.1.453-1.1.77,0,.388.546.647,1.236.975,1.1.521,2.46,1.17,2.453,2.695l.056-.08c-.011,1.92-1.814,3.16-4.592,3.16Zm7.3-.08H23.257L27.211.87a1.2,1.2,0,0,1,1.1-.68h2.2l2.135,9.249H30.206l-.319-1.38H26.571l-.539,1.38ZM28.653,2.69,27.265,6.16h2.191ZM13.985,9.41H11.342l2.2-9.25h2.642l-2.2,9.249ZM8.2,9.38H5.33l-2.1-7.39A1.015,1.015,0,0,0,2.6,1.18,11.708,11.708,0,0,0,0,.4L.066.13H4.548A1.2,1.2,0,0,1,5.77,1.07l1.1,5.35L9.613.13h2.863L8.2,9.379Z"
          transform="translate(9.16 9.232)"
          fill="#2a2a6c"
        />
      </svg>
    </div>
  );
};
